import { Storage } from "@/services/Storage";
import axios from "axios";
import queryStringify from "qs-stringify";
import { hardwareBridge } from '@/services/hardwareBridge';

export default {
    name: 'lay-by',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        searchLayByCustomers: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            return axios.get(serverApi + `layby/${store.StoreDB}/customers`, {
                data: payload
            }).then(({ data }) => data).catch(err => errorHandler.tomcatError(err))
        },
        getLayBuyByID: async (context, id) => {
            let store = await Storage.getDefaultStore();
            return axios.get(serverApi + `layby/${store.StoreDB}/${id}`)
                .then(({ data }) => data).catch(err => errorHandler.tomcatError(err))
        },
        getLayBuyItems: async (context, id) => {
            let store = await Storage.getDefaultStore();
            return axios.get(serverApi + `layby/${store.StoreDB}/${id}/items`)
                .then(({ data }) => data).catch(err => errorHandler.tomcatError(err))
        },
        searchLayBySales: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            payload = {
                ...context.getters.getGlobalDateRange,
                ...payload
            }
            payload = `?` + queryStringify(payload);
            return axios.get(serverApi + `layby/${store.StoreDB}` + payload)
                .then(({ data }) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        createLayByCustomer: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let user = await Storage.getCurrentUser();
            payload.pc = settings.PC;
            payload.createdby = user.Username;
            return axios.post(serverApi + `layby/${store.StoreDB}/customer`, payload)
                .catch(err => errorHandler.tomcatError(err))
        },

        // Initial step for handling Kazang payments
        firstKazangPaymentStepLayBy: async ({ dispatch, getters }, payload) => {
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let saleDetails = getters.getSaleDetails;
            let amount = Number(saleDetails.total) - Number(getters.getSaleDiscount.total);
            if (typeof payload === `object` && payload.onlyPayment) {
                amount = payload.amount;
                payload = { customerContact: payload.customerContact, onlyPayment: true, layByID: payload.id }; // Adjust payload for simple payment scenario

                // Validate amount for onlyPayment scenario
                if (amount <= 0) {
                    throw new Error('Amount must be greater than 0.');
                }

                return dispatch('sendSimplePaymentLayBy', { payload, store, amount });
            }

            // Validate amount is greater than 0
            if (amount <= 0) {
                throw new Error('Amount must be greater than 0. Please add items to the cart.');
            }

            let valid = {
                PC: settings.PC,
                items: getters.getSaleLines
            };
            return axios.post(serverApi + `invoice/${store.StoreDB}/checkStockAvailability`, valid)
                .then(({ data }) => {
                    if (data.valid) {
                        payload = { customerContact: payload }; // Adjust payload for simple payment scenario
                        return dispatch('sendSimplePaymentLayBy', { payload, store, amount });
                    }
                    throw new Error(data.errorMessage)
                }).catch(err => errorHandler.tomcatError(err));
        },

        // Sends a simpler payment request when payload is not an object
        sendSimplePaymentLayBy: async ({ dispatch, getters }, { payload, store, amount }) => {
            let settings = await Storage.getDeviceSettings();
            const msisdn = payload.customerContact;
            const splitAmount = Number(amount.toFixed(2));
            const network = await dispatch('checkCustomerNetwork', msisdn);
            const localid = `kaz-${Date.now()}-${Math.floor(Math.random() * 1e6)}`;
            const pc = encodeURIComponent(settings.PC || 'Online');
            const url = `${serverApi}api/payments/kazang/${store.StoreDB}?pc=${pc}`;

            try {
                const { data } = await axios.post(url, {
                    localid,
                    amount: splitAmount,
                    msisdn,
                    network
                });
                const reference = data && (data.LocalID || data.localid) ? (data.LocalID || data.localid) : localid;
                data.customerContact = payload.customerContact;
                data.onlyPayment = payload.onlyPayment;
                data.layByID = payload.layByID;
                return dispatch('handlePaymentResponseLayBy', {
                    data: { SecondRefrence: reference, Response: '0', ...data },
                    amount
                });
            } catch (err) {
                return dispatch('handlePaymentErrorLayBy', err);
            }
        },

        // Handles the response from payment API calls
        handlePaymentResponseLayBy: ({ dispatch }, { data, amount, payload = null }) => {
            if (!data.secondStep && data.Response === '0') {
                if (data.onlyPayment) {
                    let obj = {
                        id: data.layByID,
                        paymentMethod: `Kazang`,
                        amount
                    }
                    return dispatch(`acceptLayByPayment`, obj)
                }
                return dispatch('processKazangLayByPayment', {
                    amount,
                    SecondRefrence: data.SecondRefrence
                });
            } else if (data.Response === '3' || data.Response === '41') {
                return dispatch('resetKazangUser', data.Response);
            } else if (data.Response !== '0') {
                throw new Error(data.Print);
            }
            return dispatch('retryKazangPaymentStep', { data, payload });
        },

        // Manages retry mechanism for payment steps
        retryKazangPaymentStepLayBy: ({ dispatch }, { data, payload }) => {
            let attemptCount = 0;
            const maxAttempts = 35;
            let lastError = null;

            return new Promise((resolve, reject) => {
                const attemptKazangStep = () => {
                    attemptCount++;

                    if (attemptCount > maxAttempts) {
                        console.error('Max attempts reached. Stopping retries.');
                        reject(lastError || 'Max attempts reached without specific error message.');
                        return;
                    }

                    return dispatch('secondKazangStep', { data, payload })
                        .then(response => {
                            if (response.success) {
                                resolve(response);  // Resolve on successful response
                                return;
                            } else {
                                // Log and prepare for another retry
                                lastError = response.message || 'Non-successful response.';
                                setTimeout(attemptKazangStep, 3000);  // Retry after a delay
                            }
                        })
                        .catch(error => {
                            // Even on errors, prepare for another retry unless max attempts are reached
                            lastError = error.toString();
                            console.error(`Dispatch error on attempt ${attemptCount}: ${lastError}`);
                            setTimeout(attemptKazangStep, 3000);
                        });
                };

                attemptKazangStep();  // Initiate the first attempt
            });
        },

        // Handles any payment errors
        handlePaymentError: ({ commit }, err) => {
            commit('clearKazangSession');
            errorHandler.tomcatError(err, true);
            return Promise.reject(err); // Ensuring errors are propagated back if necessary
        },

        processLayByPayment: async (context, payload) => {
            let store = await Storage.getDefaultStore();

            // Clone payload to ensure mutability and avoid side effects
            let data = { ...payload };

            // Ensure the LayBy-specific fields are present
            // Backend expects 'amount' field for initial payment
            // Fix for SQL Exception: 'amount' field doesn't have a default value
            // We must ensure amount is always set, even if it's 0
            data.amount = data.paidAmount;

            // Fix for NPE on backend: explicitly set refund to false
            data.refund = false;

            return axios.post(serverApi + `layby/${store.StoreDB}/create`, data)
                .then(async ({ data }) => {
                    // Print the LayBy receipt
                    context.dispatch(`printLayBySale`, data.id);

                    // Clear all sale data
                    return Promise.all([
                        context.commit('setCurrentSale', 0),
                        context.commit('setTipAmount', 0),
                        context.commit('clearDiscount'),
                        context.commit('setSaleDetails', {}),
                        context.commit('setCurrentLines', []),
                        context.dispatch('setCustomer', ""),
                        context.commit('setLPO', {
                            debtorID: ``,
                            lpoNumber: undefined,
                        }),
                        context.commit('setOpenTableName', null),
                        context.commit('clearSale')
                    ]).then(() => {
                        // Clear localStorage to prevent reloading cleared sale
                        localStorage.removeItem('currentSaleLines');
                        return data;
                    });
                }).catch(err => {
                    errorHandler.tomcatError(err);
                    throw err; // Propagate error so UI doesn't show success
                });
        },
        processKazangLayByPayment: async (context, payload) => {
            let saleDetails = context.getters.getSaleDetails;
            saleDetails.type = `Kazang`;
            let saleData = await context.$store.dispatch('parseInvoice', saleDetails);
            saleData.paidAmount = payload.amount;
            return context.dispatch(`processLayByPayment`);
        },
        manuallyProcessLayBy: async (context, id) => {
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let user = await Storage.getCurrentUser();
            let payload = {
                deviceId: settings.PC,
                user: user.Username,
                amount: 0,
                paymentMethod: 'Cash'
            };
            return axios.post(serverApi + `layby/${store.StoreDB}/${id}/processLayby`, payload)
                .then(() => context.dispatch(`printLayBySale`, id))
                .catch(err => errorHandler.tomcatError(err))
        },
        acceptLayByPayment: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            payload.deviceId = settings.PC;
            let user = await Storage.getCurrentUser();
            payload.user = user.Username;
            return axios.post(serverApi + `layby/${store.StoreDB}/${payload.id}/payment`, payload)
                .then(() => context.dispatch(`printLayBySale`, payload.id))
                .catch(err => errorHandler.tomcatError(err))
        },
        printLayBySale: async (context, id) => {
            let user = await Storage.getCurrentUser();
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let pcName = (window?.hardwareIPC || window?.electronBridge) ? await hardwareBridge.getPcName() : await Device.getPCName();

            return axios.post(printVoid + `printing/${store.StoreDB}/printLayBy/${id}?user=${user.Username}&PC=${pcName}`, settings)
                .then(({ data }) => {
                    try {
                        return context.dispatch(`sendPrintToLocal`, data);
                    } catch (e) {
                        console.error('Print error:', e);
                        return errorHandler.tomcatError(e, false, `Print Error`);
                    }
                })
                .catch(err => errorHandler.tomcatError(err, false, `Print Error`));

        },
    }
}
